module.exports = __webpack_public_path__ + "static/media/babel-logo.085e3faf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/modern-javascript/assets/babel-logo.jpg
// module id = 1533
// module chunks = 0